import React from 'react';
import { CheckIcon } from 'lucide-react';
type PricingProps = {
  propertiesCount?: number;
  waitlistCount?: number;
};
export function Pricing({
  propertiesCount = 45,
  waitlistCount = 127
}: PricingProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="precios" className="py-8 sm:py-12 md:py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-266">
      <div className="max-w-7xl mx-auto" data-id="element-267">
        <div className="text-center mb-6 sm:mb-8 md:mb-12" data-id="element-268">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4" data-id="element-269">
            Planes para cada corredor
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-4 sm:mb-6" data-id="element-270">
            Publica gratis y escala según tu volumen de solicitudes de canje
          </p>
        </div>

        {/* GRID PLANES */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 max-w-6xl mx-auto mb-6 sm:mb-8 items-stretch" data-id="element-271">
          {/* PLAN GRATIS */}
          <div className="h-full bg-white rounded-2xl border-2 border-emerald-600 hover:shadow-lg transition-all flex flex-col" data-id="element-272">
            <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-273">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-274">
                Plan Gratuito
              </h3>
              <p className="text-xs font-semibold inline-flex items-center gap-2 px-2 py-1 rounded-full bg-emerald-100 text-emerald-900 mb-3" data-id="element-275">
                Gratis para siempre
              </p>

              <div className="flex items-baseline gap-2" data-id="element-276">
                <span className="text-2xl sm:text-3xl font-bold text-gray-900" data-id="element-277">
                  $0
                </span>
                <span className="text-xs sm:text-sm text-gray-500" data-id="element-278">/ mes</span>
              </div>

              <p className="text-xs text-gray-600 mt-2 mb-4" data-id="element-279">
                Publica propiedades gratis. Incluye 3 créditos mensuales para
                solicitar canjes.
              </p>

              <ul className="space-y-2.5 sm:space-y-3 mb-6" data-id="element-280">
                <li className="flex items-start space-x-2" data-id="element-281">
                  <CheckIcon className="w-4 h-4 text-emerald-600" data-id="element-282" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-283">
                    Publica propiedades gratis
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-284">
                  <CheckIcon className="w-4 h-4 text-emerald-600" data-id="element-285" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-286">
                    3 créditos mensuales para solicitar canjes
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-287">
                  <CheckIcon className="w-4 h-4 text-emerald-600" data-id="element-288" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-289">
                    Crédito devuelto si te rechazan
                  </span>
                </li>
              </ul>

              <button onClick={() => scrollToSection('unirme')} className="mt-auto w-full px-4 sm:px-6 py-2.5 sm:py-3 text-sm font-semibold text-emerald-900 bg-white border-2 border-emerald-600 rounded-xl hover:bg-emerald-50 transition-all" data-id="element-290">
                Crear cuenta gratis
              </button>
            </div>
          </div>

          {/* PLAN PRO */}
          <div className="h-full bg-white rounded-2xl border-2 border-indigo-900 hover:shadow-lg transition-all flex flex-col relative" data-id="element-291">
            <div className="absolute top-3 right-3 px-2 py-1 bg-indigo-100 text-indigo-900 text-xs font-bold rounded-full" data-id="element-292">
              RECOMENDADO
            </div>

            <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-293">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-294">
                Plan Pro
              </h3>

              <div className="flex items-baseline gap-2 mb-2" data-id="element-295">
                <span className="text-2xl sm:text-3xl font-bold text-gray-900" data-id="element-296">
                  $15.000
                </span>
                <span className="text-xs sm:text-sm text-gray-500" data-id="element-297">/ mes</span>
              </div>

              <p className="text-xs text-gray-600" data-id="element-298">
                Publica propiedades gratis. 20 créditos mensuales para solicitar
                canjes.
              </p>

              <ul className="space-y-2.5 sm:space-y-3 my-6" data-id="element-299">
                <li className="flex items-start space-x-2" data-id="element-300">
                  <CheckIcon className="w-4 h-4 text-indigo-900" data-id="element-301" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-302">
                    Publica propiedades gratis
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-303">
                  <CheckIcon className="w-4 h-4 text-indigo-900" data-id="element-304" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-305">
                    20 créditos mensuales para solicitar canjes
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-306">
                  <CheckIcon className="w-4 h-4 text-indigo-900" data-id="element-307" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-308">
                    Crédito devuelto si te rechazan
                  </span>
                </li>
              </ul>

              <button onClick={() => scrollToSection('unirme')} className="mt-auto w-full px-4 sm:px-6 py-2.5 sm:py-3 text-sm font-semibold text-white bg-indigo-900 rounded-xl hover:bg-indigo-800 transition-all" data-id="element-309">
                Pasar a Pro
              </button>
            </div>
          </div>

          {/* PLAN EMPRESA */}
          <div className="h-full bg-white rounded-2xl border-2 border-purple-700 hover:shadow-lg transition-all flex flex-col relative" data-id="element-310">
            <div className="absolute top-3 right-3 px-2 py-1 bg-purple-100 text-purple-900 text-xs font-bold rounded-full" data-id="element-311">
              EMPRESA
            </div>

            <div className="p-4 sm:p-6 flex-1 flex flex-col" data-id="element-312">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-313">
                Plan Empresa
              </h3>

              <div className="flex items-baseline gap-2 mb-2" data-id="element-314">
                <span className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-315">
                  Precio personalizado
                </span>
              </div>

              <p className="text-xs text-gray-600 mb-4" data-id="element-316">
                Solución a medida para equipos y corredoras. Créditos y
                funcionalidades según tus necesidades.
              </p>

              <ul className="space-y-2.5 sm:space-y-3 mb-6" data-id="element-317">
                <li className="flex items-start space-x-2" data-id="element-318">
                  <CheckIcon className="w-4 h-4 text-purple-700" data-id="element-319" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-320">
                    Publica propiedades gratis
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-321">
                  <CheckIcon className="w-4 h-4 text-purple-700" data-id="element-322" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-323">
                    Créditos personalizados
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-324">
                  <CheckIcon className="w-4 h-4 text-purple-700" data-id="element-325" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-326">
                    Gestión de equipos
                  </span>
                </li>
                <li className="flex items-start space-x-2" data-id="element-327">
                  <CheckIcon className="w-4 h-4 text-purple-700" data-id="element-328" />
                  <span className="text-xs sm:text-sm text-gray-700" data-id="element-329">
                    Soporte prioritario
                  </span>
                </li>
              </ul>

              <button onClick={() => scrollToSection('unirme')} className="mt-auto w-full px-4 sm:px-6 py-2.5 sm:py-3 text-sm font-semibold text-white bg-purple-700 rounded-xl hover:bg-purple-600 transition-all" data-id="element-330">
                Solicitar cotización
              </button>
            </div>
          </div>
        </div>

        {/* Nota sobre créditos */}
        <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4 sm:p-6 max-w-4xl mx-auto mb-6" data-id="element-331">
          <p className="text-sm text-indigo-900 text-center" data-id="element-332">
            <strong data-id="element-333">Sistema de créditos:</strong> Cada solicitud de canje cuesta
            1 crédito. Si te rechazan, el crédito se devuelve automáticamente.
            Si aceptan, el crédito se consume.
          </p>
        </div>

        {/* Nota sobre red privada */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 sm:p-6 max-w-4xl mx-auto mb-6" data-id="element-334">
          <p className="text-sm text-amber-900 text-center" data-id="element-335">
            <strong data-id="element-336">Red privada:</strong> Canjee es una red exclusiva. Solo
            puedes acceder si tienes una cuenta activa.
          </p>
        </div>

        {/* Métricas */}
        <div className="max-w-4xl mx-auto mb-6 sm:mb-8" data-id="element-337">
          <p className="text-xs sm:text-sm text-gray-600 text-center" data-id="element-338">
            Hoy ya hay <strong data-id="element-339">{propertiesCount}</strong> propiedades de canje
            cargadas y <strong data-id="element-340">{waitlistCount}</strong> corredores en la lista
            de espera.
          </p>
        </div>
      </div>
    </section>;
}